import { create } from 'zustand';
import type { TestResult } from '@presentation/services/scriptSandbox';

interface TabTestState {
  tests: TestResult[];
  scriptError: string | null;
}

interface TestResultsState {
  results: Record<string, TabTestState | undefined>;
  setResults: (tabKey: string, state: TabTestState) => void;
  clear: (tabKey: string) => void;
}

export const useTestResultsStore = create<TestResultsState>((set) => ({
  results: {},
  setResults: (tabKey, state) => set((prev) => ({ results: { ...prev.results, [tabKey]: state } })),
  clear: (tabKey) =>
    set((prev) => {
      const results = { ...prev.results };
      delete results[tabKey];
      return { results };
    }),
}));
